import Vue from 'vue'
import Vuex from 'vuex'
import profile from '@/store/modules/profile'
import auth from '@/store/modules/auth'
import loading from "@/store/modules/loading";
import sideBarModule from '@/view/sidebar/store-module';

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    profile,
    auth,
    loading,
    sideBar: sideBarModule,
  },
  strict: debug,
})